import { render, staticRenderFns } from "./icon-info.vue?vue&type=template&id=d2ae6520&scoped=true&"
import script from "./icon-info.vue?vue&type=script&lang=js&"
export * from "./icon-info.vue?vue&type=script&lang=js&"
import style0 from "./icon-info.vue?vue&type=style&index=0&id=d2ae6520&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ae6520",
  null
  
)

export default component.exports